export default __webpack_public_path__ + "station-defect-imbalance-gray.png?9a28b3aa79ea8c20a3dbcf623e3c9c0d";